import { useQuery } from "@tanstack/react-query";
import { apiClient, type DisputesQuery } from "../lib/api-client";
import { queryKeys } from "../lib/queryClient";
import { POLL } from "../lib/polling";

/** MODERATOR/ADMIN only — see `useAuthPrincipal()` for the role gate. */
export function useDisputes(query: DisputesQuery = {}) {
  return useQuery({
    queryKey: queryKeys.disputes(query),
    queryFn: ({ signal }) => apiClient.listDisputes(query, signal),
    refetchInterval: POLL.list,
  });
}
